var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
        [
          _c("c-table", {
            ref: "processTable2",
            attrs: {
              title: "단위공정 목록",
              columns: _vm.grid.columns,
              data: _vm.grid.data,
              columnSetting: false,
              isFullScreen: false,
              usePaging: false,
              expandAll: true,
              filtering: false,
            },
            on: { rowClick: _vm.rowClick },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9" },
        [
          _c(
            "q-form",
            { ref: "editForm" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "단위공정 상세" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable && this.parentProcess !== null
                            ? _c("c-btn", {
                                attrs: { label: "신규 단위공정", icon: "add" },
                                on: { btnClicked: _vm.addChild },
                              })
                            : _vm._e(),
                          _vm.editable
                            ? _c("c-btn", {
                                attrs: {
                                  disabled: !_vm.saveable,
                                  url: _vm.saveUrl,
                                  isSubmit: _vm.isSave,
                                  param: _vm.data,
                                  mappingType: _vm.saveType,
                                  label: "저장",
                                  icon: "save",
                                },
                                on: {
                                  beforeAction: _vm.saveData,
                                  btnCallback: _vm.saveCallback,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable && _vm.dataeditable,
                            required: true,
                            label: "단위공정명",
                            name: "processName",
                          },
                          model: {
                            value: _vm.data.processName,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "processName", $$v)
                            },
                            expression: "data.processName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable && _vm.dataeditable,
                            label: "단위공정 관리번호",
                            name: "processNo",
                          },
                          model: {
                            value: _vm.data.processNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "processNo", $$v)
                            },
                            expression: "data.processNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable && _vm.dataeditable,
                            required: true,
                            label: "정렬순서",
                            name: "orderNo",
                          },
                          model: {
                            value: _vm.data.orderNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "orderNo", $$v)
                            },
                            expression: "data.orderNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-10" },
                      [
                        _c("c-dept-multi", {
                          attrs: {
                            label: "관련부서",
                            editable: _vm.editable && _vm.dataeditable,
                            parentCheckDepts: _vm.data.managementDepts,
                            plantCd: _vm.data.plantCd,
                            name: "managementDepts",
                          },
                          model: {
                            value: _vm.data.managementDepts,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "managementDepts", $$v)
                            },
                            expression: "data.managementDepts",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-checkbox", {
                          attrs: {
                            editable: _vm.editable && _vm.dataeditable,
                            isFlag: true,
                            label: "사용여부",
                            name: "useFlag",
                          },
                          model: {
                            value: _vm.data.useFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "useFlag", $$v)
                            },
                            expression: "data.useFlag",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-multi-select", {
                          attrs: {
                            editable: _vm.editable && _vm.dataeditable,
                            disable: !_vm.editable && !_vm.dataeditable,
                            comboItems: _vm.lineItems,
                            itemText: "lineCd",
                            itemValue: "lineId",
                            label: "관련 라인(LINE)",
                            name: "linearr",
                          },
                          model: {
                            value: _vm.data.linearr,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "linearr", $$v)
                            },
                            expression: "data.linearr",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-multi-select", {
                          attrs: {
                            editable: _vm.editable && _vm.dataeditable,
                            disable: !_vm.editable && !_vm.dataeditable,
                            comboItems: _vm.placeItems,
                            itemText: "placeName",
                            itemValue: "placeId",
                            label: "관련 장소(층)",
                            name: "placearr",
                          },
                          model: {
                            value: _vm.data.placearr,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "placearr", $$v)
                            },
                            expression: "data.placearr",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("c-select", {
                          attrs: {
                            editable: _vm.editable && _vm.dataeditable,
                            codeGroupCd: "WORK_CYCLE_CD",
                            type: "edit",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "workCycleCd",
                            label: "작업발생 주기",
                          },
                          model: {
                            value: _vm.data.workCycleCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "workCycleCd", $$v)
                            },
                            expression: "data.workCycleCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable && _vm.dataeditable,
                            type: "number",
                            label: "작업시간(1회)",
                            name: "workingTime",
                          },
                          model: {
                            value: _vm.data.workingTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "workingTime", $$v)
                            },
                            expression: "data.workingTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable && _vm.dataeditable,
                            label: "사용온도",
                            type: "number",
                            name: "temperature",
                            suffix: "°C",
                          },
                          model: {
                            value: _vm.data.temperature,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "temperature", $$v)
                            },
                            expression: "data.temperature",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("c-upload", {
                          attrs: {
                            attachInfo: _vm.attachInfo1,
                            editable:
                              _vm.editable &&
                              _vm.attachable &&
                              _vm.dataeditable,
                            label: "단위공정 사진",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }